$(document).ready(function(){
  if (!window.luxon || !luxon.DateTime) { return; } // luxon loads async; skip quietly if not ready
  var DateTime = luxon.DateTime;
  var d = new DateTime.local().setZone('America/Chicago');
  //console.log(d.toString());
  var dateDayString = d.day.toString();
  if (dateDayString.length == 1) {
    var dateDayString = "0" + dateDayString;
  }
  var dateMonthString = (d.month).toString();
  if (dateMonthString.length == 1) {
    var dateMonthString = "0" + dateMonthString;
  }
  var strDate = d.year.toString() + dateMonthString + dateDayString;
  var strDateNum = parseInt(strDate);
  var startingDivs = $('*[class*="start"]');
  //console.log(startingDivs);
  //console.log(startingDivs[0].className.split(/\s+/));
  var i;
  for (i = 0; i < startingDivs.length; i++) {
    var classList = startingDivs[i].className.split(/\s+/);
    var j;
    for (j = 0; j < classList.length; j++) {
      if (classList[j].startsWith("start")) {
        var startDateNum = parseInt(classList[j].split("-")[1]);
        //console.log("Div Start: " + startDateNum);
        //console.log("Today: " + strDateNum);
        if (startDateNum > strDateNum) {
          $(startingDivs[i]).hide();
        }
      }
      if (classList[j].startsWith("end")) {
        var endDateNum = parseInt(classList[j].split("-")[1]);
        //console.log(endDateNum);
        if (endDateNum < strDateNum) {
          $(startingDivs[i]).hide();
        }
      }
    }
  }
});

/* ===== Announcement bar countdown timers ===== */
/* Anchored to store time (America/Chicago) via Luxon so every visitor's
   timer hits zero at the same real moment, regardless of their local clock. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function targetMillis(dateStr, timeStr) {
    if (!dateStr) { return null; }
    var iso = dateStr + 'T' + (timeStr && timeStr.length ? timeStr : '23:59');
    if (window.luxon && window.luxon.DateTime) {
      var dt = window.luxon.DateTime.fromISO(iso, { zone: 'America/Chicago' });
      if (dt.isValid) { return dt.toMillis(); }
    }
    // Fallback if Luxon is unavailable: interpret in the visitor's local time.
    var d = new Date(iso);
    return isNaN(d.getTime()) ? null : d.getTime();
  }

  function format(ms) {
    var totalSeconds = Math.floor(ms / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var out = days > 0 ? days + 'd ' : '';
    return out + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function tick() {
    var els = document.querySelectorAll('[data-countdown]');
    var now = Date.now();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.hasAttribute('data-expired')) { continue; }
      var clock = el.querySelector('.announcement-countdown__clock');
      if (!clock) { continue; }
      var target = targetMillis(el.getAttribute('data-end-date'), el.getAttribute('data-end-time'));
      if (target === null) { continue; }
      var diff = target - now;
      if (diff <= 0) {
        if (el.getAttribute('data-expired-behavior') === 'hide') {
          var slide = el.closest ? el.closest('.announcement-slider__slide') : null;
          (slide || el).style.display = 'none';
        } else {
          el.setAttribute('data-expired', '');
          clock.textContent = el.getAttribute('data-expired-text') || '';
        }
      } else {
        clock.textContent = format(diff);
      }
    }
  }

  function start() { tick(); setInterval(tick, 1000); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();